import { TeamOutlet } from 'pages/teams/outlet/TeamOutlet';

export const TeamLayout = () => <TeamOutlet />;
